import { render, staticRenderFns } from "./UsedPartsInfoListView.vue?vue&type=template&id=c04c48e8"
import script from "./UsedPartsInfoListView.vue?vue&type=script&lang=js"
export * from "./UsedPartsInfoListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c04c48e8')) {
      api.createRecord('c04c48e8', component.options)
    } else {
      api.reload('c04c48e8', component.options)
    }
    module.hot.accept("./UsedPartsInfoListView.vue?vue&type=template&id=c04c48e8", function () {
      api.rerender('c04c48e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/usedpartsinfo/UsedPartsInfoListView.vue"
export default component.exports